module.exports = __webpack_public_path__ + "/images/shop/order-confirmation/marker.png";